import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fw-800" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { style: {"display":"flex"} }
const _hoisted_5 = { style: {"width":"50%"} }
const _hoisted_6 = { class: "fw-500 fs-10" }
const _hoisted_7 = { class: "fw-800 fs-15 text-success" }
const _hoisted_8 = {
  class: "mt-3",
  style: {"display":"flex","color":"#885200","justify-content":"start"}
}
const _hoisted_9 = { class: "mr-4" }
const _hoisted_10 = { class: "fw-800" }
const _hoisted_11 = { class: "mt-2" }
const _hoisted_12 = { class: "text-subtitle-1 mb-0" }
const _hoisted_13 = { class: "text-error" }
const _hoisted_14 = { class: "mt-2" }
const _hoisted_15 = { class: "fw-800" }
const _hoisted_16 = {
  class: "my-2",
  style: {"background":"#00092d","padding":"10px","border":"2px solid #ffc200"}
}
const _hoisted_17 = {
  style: {"color":"#fff"},
  class: "fw-900"
}
const _hoisted_18 = { style: {"color":"#92ff00"} }
const _hoisted_19 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_20 = {
  key: 1,
  class: "text-success"
}
const _hoisted_21 = {
  key: 2,
  class: "text-error"
}
const _hoisted_22 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_23 = {
  style: {"width":"50%"},
  class: "px-5"
}
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = {
  key: 0,
  class: "fw-800 ml-3 mr-1 px-2",
  style: {"background":"red","color":"#fff !important"}
}
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "mt-2" }
const _hoisted_28 = ["href"]
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "dialog-footer" }

import {
  ref,
  inject,
  computed,
  onMounted,
  watch,
} from "vue";
import ApiService from "@/core/services/Transaction.ts";
import { LoadingService } from "@/core/plugins/loading";
import { ElNotification } from "element-plus";
import SvgSprite from "@/components/shared/SvgSprite.vue";
import { ElMessageBox } from "element-plus";

import UploadSlip from "@/views/sellstock/transaction/UploadSlip";
import UplineTree from "@/views/sellstock/downline/UplineTree";


export default /*@__PURE__*/_defineComponent({
  __name: 'PayDetail',
  props: {
  modelValue: Boolean,
  selectedOrder: Object,
},
  setup(__props, { emit: __emit }) {

const $loading = inject("$loading") as LoadingService;

const items = ref("");
const countdown = ref("");

const props = __props;

const emit = __emit;

const isDialogPayment = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit("update:modelValue", value);
  },
});

const handleDialogClose = () => {
  items.value = "";
  emit("update:modelValue", false);
};

const openOpyPaymentPage = (data: any) => {
  if (data?.provider?.toLowerCase() !== "opy" || !data?.payment_url) return;

  const popup = window.open(data.payment_url, "_blank");
  if (popup) {
    popup.opener = null;
    return;
  }

  ElNotification({
    title: "Payment page",
    message: "Pop-up was blocked. Please click Open payment page.",
    type: "warning",
  });
};

const getDetail = async (id: any, autoOpenPayment = false) => {
  $loading.startLoading();
  if (!props.selectedOrder?.order_id) return;
  const resp = await ApiService.payDetail({
    order_id: id ? id : props.selectedOrder.order_id,
  });
  if (resp.status == "success") {
    ElNotification({
      title: resp.status,
      message: resp.msg,
      type: resp.status,
    });

    if (resp.data || resp.data != null || resp.data != undefined) {
      items.value = resp;
      updateCountdown();
      emit("update:modelValue", true);
      if (autoOpenPayment) {
        openOpyPaymentPage(resp.data);
      }
    }
  } else {
    ElNotification({
      title: "Error",
      message: resp.error || resp.msg,
      type: "error",
    });
    emit("update:modelValue", false);
  }
  $loading.endLoading();
};

const getChipColor = (status: string) => {
  if (status === 2) {
    return "error";
  } else if (status === 1) {
    return "success";
  } else if (status === 0) {
    return "secondary";
  } else {
    return "default";
  }
};

const isDialogVisibleUpload = ref(false);
const selectedOrder = ref("");

const showSlip = ref(false);

const closeUploadDialog = () => {
  isDialogVisibleUpload.value = false;
  selectedOrder.value = null;
};

const handleUpload = (item: any) => {
  isDialogVisibleUpload.value = true;
  selectedOrder.value = item;
};

const popupUplineTree = ref(false);
const selectUser = ref("");

const clickPushUser = (item: any) => {
  popupUplineTree.value = true;
  selectUser.value = item;
};

watch(
  () => popupUplineTree.value,
  (newVal) => {
    if (!newVal) {
      selectUser.value = "";
    }
  },
  { immediate: true }
);

const handleUploadSubmit = (data) => {
  getDetail();
  closeUploadDialog();
};

const formatDate = (dateStr: string) => {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

const updateCountdown = () => {
  const expiryDate = new Date(items.value.data.expired_at);
  const interval = setInterval(() => {
    const now = new Date();
    const remainingTime = expiryDate.getTime() - now.getTime();

    if (remainingTime <= 0) {
      clearInterval(interval);
      countdown.value = "Expired";
    } else {
      const hours = Math.floor(remainingTime / (1000 * 60 * 60));
      const minutes = Math.floor(
        (remainingTime % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
      countdown.value = `${hours}h ${minutes}m ${seconds}s`;
    }
  }, 1000);
};

const formattedExpiredAt = (expiredAt: string) => {
  return formatDate(expiredAt);
};

watch(
  () => props.selectedOrder,
  (newVal) => {
    if (newVal) {
      getDetail(undefined, true);
    }
  },
  { immediate: true }
);

const reportTransaction = async (data: any) => {
  try {
    await ElMessageBox.confirm(
      `Are you sure you want to report transaction ${data.order_id}?`,
      "Confirm Report",
      {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning",
        cancelButtonClass: "bg-error",
      }
    );

    const resp = await ApiService.reportTransactionSubmit({
      order_id: data.order_id,
    });

    ElNotification({
      title: resp.status,
      message: resp.msg,
      type: resp.status,
    });
  } catch (error) {
    console.log("Cancelled or failed", error);
  }
};
const formatCurrency = (amount: number | null | undefined): string => {
  if (amount === null || amount === undefined) return "฿0.00";

  return new Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
    minimumFractionDigits: 2,
  }).format(amount);
};

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: isDialogPayment.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isDialogPayment).value = $event)),
      "align-center": "",
      "close-on-click-modal": false,
      onClose: handleDialogClose,
      width: "90%"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, "Order ID: " + _toDisplayString(items.value.data?.order_id || "Loading..."), 1),
          _createElementVNode("div", null, [
            _cache[8] || (_cache[8] = _createTextVNode(" Username: ")),
            _createElementVNode("span", {
              class: "c-pointer text-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (clickPushUser(items.value?.data.username)))
            }, _toDisplayString(items.value.data?.username), 1),
            (items.value.data?.nickname)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(" + _toDisplayString(items.value.data?.nickname) + ")", 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_el_button, {
            variant: "flat",
            size: "large",
            rounded: "md",
            type: "danger",
            onClick: handleDialogClose
          }, {
            default: _withCtx(() => _cache[23] || (_cache[23] = [
              _createTextVNode("Cancel")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (items.value?.data)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[9] || (_cache[9] = _createTextVNode(" Amount: ")),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(formatCurrency(items.value?.data?.amount)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(SvgSprite, {
                        name: "custom-warning-fill",
                        style: {"width":"50px","height":"50px"}
                      })
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", null, [
                        _createVNode(_component_v_avatar, {
                          size: "5",
                          class: "mr-2",
                          color: "#885200"
                        }),
                        _cache[10] || (_cache[10] = _createTextVNode(" Please transfer the exact specified amount correctly. "))
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(_component_v_avatar, {
                          size: "5",
                          class: "mr-2",
                          color: "#885200"
                        }),
                        _cache[11] || (_cache[11] = _createTextVNode(" โปรดโอนเงินให้ตรงกับจำนวนที่ระบุไว้อย่างถูกต้อง "))
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(_component_v_avatar, {
                          size: "5",
                          class: "mr-2",
                          color: "#885200"
                        }),
                        _cache[12] || (_cache[12] = _createTextVNode(" 请准确转账指定的金额。 "))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_v_card, {
                      variant: "outlined",
                      elevation: "0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, {
                          class: "p-8",
                          style: {"background":"transparent !important"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, null, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_avatar, {
                                  variant: "tonal",
                                  color: "warning",
                                  rounded: "md"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(SvgSprite, {
                                      name: "custom-clock-outline",
                                      style: {"width":"20px","height":"20px"}
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("h6", _hoisted_12, [
                                  _createElementVNode("p", null, " Expired At: " + _toDisplayString(formattedExpiredAt(items.value.data?.expired_at)), 1),
                                  _createElementVNode("p", _hoisted_13, "Time Left: " + _toDisplayString(countdown.value), 1)
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_v_card, {
                      variant: "outlined",
                      elevation: "0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, {
                          class: "p-8",
                          style: {"background":"transparent !important"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("p", null, [
                                _createVNode(_component_v_avatar, {
                                  size: "5",
                                  class: "mr-2",
                                  color: "secondary"
                                }),
                                _cache[13] || (_cache[13] = _createTextVNode(" Please upload the payment slip after the transfer is successful. "))
                              ]),
                              _createElementVNode("p", null, [
                                _createVNode(_component_v_avatar, {
                                  size: "5",
                                  class: "mr-2",
                                  color: "secondary"
                                }),
                                _cache[14] || (_cache[14] = _createTextVNode(" กรุณาอัพโหลดสลิป หลังจากโอนสำเร็จ "))
                              ]),
                              _createElementVNode("p", null, [
                                _createVNode(_component_v_avatar, {
                                  size: "5",
                                  class: "mr-2",
                                  color: "secondary"
                                }),
                                _cache[15] || (_cache[15] = _createTextVNode(" 请在转账成功后上传付款凭证。 "))
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, "PROVIDER: " + _toDisplayString(items.value.data?.provider.toUpperCase()) + " | ", 1),
                      _cache[19] || (_cache[19] = _createElementVNode("span", null, " STATUS : ", -1)),
                      (items.value.data?.status === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                            _createVNode(SvgSprite, {
                              name: "custom-clock-outline",
                              style: {"width":"20px","height":"20px"}
                            }),
                            _cache[16] || (_cache[16] = _createTextVNode(" Pending"))
                          ]))
                        : (items.value.data?.status === 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                              _createVNode(SvgSprite, {
                                name: "custom-check-circle-fill",
                                style: {"width":"20px","height":"20px"}
                              }),
                              _cache[17] || (_cache[17] = _createTextVNode(" Success"))
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_21, [
                              _createVNode(SvgSprite, {
                                name: "custom-close-circle-outline",
                                style: {"width":"20px","height":"20px"}
                              }),
                              _cache[18] || (_cache[18] = _createTextVNode(" Failed"))
                            ]))
                    ]),
                    _createVNode(_component_v_btn, {
                      class: "fw-800 ml-3",
                      color: items.value.data?.slip_url ? 'primary' : 'warning',
                      size: "small",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (handleUpload(items.value.data)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(items.value.data?.slip_url ? "Change Slip" : "Upload Slip"), 1)
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_v_btn, {
                      class: "fw-800 mr-4",
                      color: "error",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (reportTransaction(items.value.data)))
                    }, {
                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                        _createTextVNode(" Report Transaction ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      class: "fw-800",
                      color: "info",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (getDetail()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(SvgSprite, {
                          name: "custom-refresh-2",
                          style: {"width":"20px","height":"20px"}
                        }),
                        _cache[21] || (_cache[21] = _createTextVNode(" Refresh "))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("p", null, _toDisplayString(items.value.data?.note ? "Note : " + items.value.data?.note : ""), 1),
                    _createElementVNode("p", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (getDetail(items.value.data?.link_order_id))),
                      class: "text-primary fw-800 c-pointer"
                    }, _toDisplayString(items.value.data?.link_order_id
                  ? "Link Order ID : " + items.value.data?.link_order_id
                  : ""), 1)
                  ]),
                  (!items.value.data?.slip_url)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, " No Slip "))
                    : _createCommentVNode("", true),
                  (items.value.data?.slip_url)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: items.value.data?.slip_url,
                        alt: "Slip Image",
                        style: {"width":"100%","height":"auto"}
                      }, null, 8, _hoisted_26))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                (items.value.data?.provider?.toLowerCase() === 'opy' && items.value.data?.payment_url)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "opy-pay-btn",
                      href: items.value.data.payment_url,
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, _cache[22] || (_cache[22] = [
                      _createElementVNode("span", {
                        class: "opy-pay-btn__shine",
                        "aria-hidden": "true"
                      }, null, -1),
                      _createElementVNode("span", {
                        class: "opy-pay-btn__icon",
                        "aria-hidden": "true"
                      }, [
                        _createElementVNode("svg", {
                          viewBox: "0 0 24 24",
                          fill: "none"
                        }, [
                          _createElementVNode("path", {
                            d: "M14 5h5v5M19 5l-9 9",
                            stroke: "currentColor",
                            "stroke-width": "2.2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }),
                          _createElementVNode("path", {
                            d: "M19 13v5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5",
                            stroke: "currentColor",
                            "stroke-width": "2.2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          })
                        ])
                      ], -1),
                      _createElementVNode("span", { class: "opy-pay-btn__copy" }, [
                        _createElementVNode("span", { class: "opy-pay-btn__title" }, "Open payment page"),
                        _createElementVNode("span", { class: "opy-pay-btn__sub" }, "เปิดหน้าชำระเงินในแท็บใหม่")
                      ], -1),
                      _createElementVNode("span", {
                        class: "opy-pay-btn__go",
                        "aria-hidden": "true"
                      }, "เปิดเลย", -1)
                    ]), 8, _hoisted_28))
                  : (_openBlock(), _createElementBlock("iframe", {
                      key: 1,
                      src: items.value.data?.payment_url,
                      width: "100%",
                      height: "500px",
                      frameborder: "0"
                    }, null, 8, _hoisted_29))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(UploadSlip), {
      modelValue: isDialogVisibleUpload.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((isDialogVisibleUpload).value = $event)),
      selectedOrder: selectedOrder.value,
      onSubmitUpload: handleUploadSubmit
    }, null, 8, ["modelValue", "selectedOrder"]),
    _createVNode(_unref(UplineTree), {
      modelValue: popupUplineTree.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((popupUplineTree).value = $event)),
      selectUser: selectUser.value
    }, null, 8, ["modelValue", "selectUser"])
  ], 64))
}
}

})